export const ErrorType = {
    BadRequest: "BadRequest",
    Unauthenticated: "Unauthenticated",
    Unauthorized: "Unauthorized",
    NotFound: "NotFound",
    Internal: "Internal",
};
//# sourceMappingURL=errorrType.js.map